export default __webpack_public_path__ + "static/media/1940.f389c16a.png";